import { phonePasswordLogin, phonePasswordRegister, partnerTokenLogin, getMerchantList, updateUserInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setUrlMerchantId, getUrlMerchantId, getUserInfo, setUserInfo, clearStorage } from '@/utils/storage'

const state = {
  token: getToken(),
  userInfo: getUserInfo(),
  merchantId: null,
  loading: false,
  merchants: []
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_MERCHANT_ID(state, id) {
    state.merchantId = id
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_MERCHANTS(state, merchants) {
    state.merchants = merchants
  }
}

const actions = {
  // 获取商户列表
  async fetchMerchants({ commit }) {
    try {
      const res = await getMerchantList()
      commit('SET_MERCHANTS', res.data || [])
      return res
    } catch (error) {
      console.error('获取商户列表失败:', error)
      return { data: [] }
    }
  },

  // 手机号密码登录
  async phonePasswordLogin({ commit }, { merchantId, phone, password }) {
    commit('SET_LOADING', true)
    try {
      const res = await phonePasswordLogin(merchantId, phone, password)
      const token = res.data.token
      const userInfo = res.data
      const returnedMerchantId = res.data.MerchantId || merchantId

      setToken(token)
      setUrlMerchantId(returnedMerchantId)
      setUserInfo(userInfo)

      commit('SET_TOKEN', token)
      commit('SET_MERCHANT_ID', returnedMerchantId)
      commit('SET_USER_INFO', userInfo)

      return res
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 手机号密码注册
  async phonePasswordRegister({ commit }, { merchantId, phone, password }) {
    commit('SET_LOADING', true)
    try {
      const res = await phonePasswordRegister(merchantId, phone, password)
      const token = res.data.token
      const userInfo = res.data
      const returnedMerchantId = res.data.MerchantId || merchantId

      setToken(token)
      setUrlMerchantId(returnedMerchantId)
      setUserInfo(userInfo)

      commit('SET_TOKEN', token)
      commit('SET_MERCHANT_ID', returnedMerchantId)
      commit('SET_USER_INFO', userInfo)

      return res
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 合作方免密跳转登录：商户ID完全由后端返回（服务端按配置解析，不依赖前端传入或猜测）
  async partnerTokenLogin({ commit }, { token }) {
    const res = await partnerTokenLogin(token)
    const returnedToken = res.data.token
    const userInfo = res.data
    const returnedMerchantId = res.data.merchantId

    setToken(returnedToken)
    setUrlMerchantId(returnedMerchantId)
    setUserInfo(userInfo)

    commit('SET_TOKEN', returnedToken)
    commit('SET_MERCHANT_ID', returnedMerchantId)
    commit('SET_USER_INFO', userInfo)

    return res
  },

  // 更新用户信息
  async updateUserInfo({ commit }, data) {
    commit('SET_LOADING', true)
    try {
      const res = await updateUserInfo(data)
      const userInfo = res.data

      setUserInfo(userInfo)
      commit('SET_USER_INFO', userInfo)

      return res
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 退出登录
  logout({ commit }) {
    const mid = getUrlMerchantId()
    removeToken()
    clearStorage()
    if (mid) setUrlMerchantId(mid)
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
    commit('SET_MERCHANT_ID', null)
  }
}

const getters = {
  isLoggedIn: state => !!state.token,
  userInfo: state => state.userInfo,
  token: state => state.token,
  merchants: state => state.merchants
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
